import React from "react";

import { ChooseUs, FaqSection, GetInTouch, ProductsSection, Services, WorkStreamline } from "../containers";

import HomeBanner from "./components";

import "./HomePage.scss";

const HomePage = () => {
	return (
		<div className="home-page">
			<HomeBanner />

			<ChooseUs />

			<GetInTouch />

			<Services />

			<WorkStreamline />

			<ProductsSection />

			<FaqSection />
		</div>
	);
};

export default HomePage;
